import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e40d7ac0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e40d7ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40d7ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e40d7ac0')) {
      api.createRecord('e40d7ac0', component.options)
    } else {
      api.reload('e40d7ac0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e40d7ac0&scoped=true&", function () {
      api.rerender('e40d7ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TCheckboxGroup/index.vue"
export default component.exports